import { ResponsiveValue } from '@chakra-ui/react'
import { useVehicleType } from 'app/hooks'

export const HEADER_HEIGHT = 70
export const BASE_URL = process.env.REACT_APP_BASE_URL ?? ''
export const FOUNDATION_URL = process.env.REACT_APP_FOUNDATION_URL ?? ''
// export const BASE_URL_HEALTH = 'https://suraksha-uat.zopperinsurance.com'
export const BASE_URL_HEALTH = 'https://insuranceuat.equitasbank.com/suraksha'
export const MISC_URL = 'http://misc.theblackswan.in'
export { API_ENDPOINTS } from './endpoints'
export const POSP_URL = process.env.REACT_APP_POSP_URL ?? ''
export const saodEnableDate = new Date('2018/08/31')
export const maxFileSize = 2048
export const phoneRegExp = /^[0-9]{10}$/

// export const nameRegex = new RegExp('^[a-zA-Z .]{2,50}$')
export const nameRegex = new RegExp('^(?!.*\\.\\.)[a-zA-Z .]{2,50}$')
export const LastNameRegex = new RegExp('^(?!.*\\.\\.)[a-zA-Z.]{1,50}$')

export const USER_BROKER_TYPE = {
  newUser: 'new_user',
  iCareUser: 'icare_registered_user',
  otherRegisteredUser: 'other_registered_user',
}

export const USER_REGISTRATION_TYPE = {
  registered: 'registered',
  notRegistered: 'not_registered',
}

export const nomineeMandatoryInsurers = [
  'TATA2W',
  'MG4W',
  'MG2W',
  'GDPCV',
  'hdfc_4w',
  'hdfc_2w',
  'HDGCV',
  'HE4W',
  'HE2W',
  'HDFCPC',
]

export const GenderMap: any = {
  son: 'Male',
  daughter: 'Female',
  father: 'Male',
  mother: 'Female',
  spouse: 'Female',
}

export const allInsurers = {
  digit_fw: 'GoDigit Four wheeler',
  digit_tw: 'GoDigit 2w',
  hdfc_4w: 'HDFC ERGO General Insurance Company Four Wheeler',
  hdfc_2w: 'HDFC ERGO General Insurance Company Two Wheeler',
  HDGCV: 'HDFC GCV',
  raheja_4w: 'Raheja 4W',
  religare_name: 'RELIGARE',
  navi_4w: 'Navi General Fourwheeler',
  navi_2w: 'Navi General Twowheeler',
  tata_aig_4w: 'TATA AIG 4W',
  tata_aig_2w: 'TATA AIG 2W',
  SBIFW: 'SBI General Insurance Four Wheeler',
  SBITW: 'SBI General Insurance Two Wheeler',
  SBIGCV: 'SBI General Insurance GCV',
  BJ4W: 'Bajaj 4W',
  BJ2W: 'Bajaj 2W',
  BJGCV: 'Bajaj Good Carrying Vehicle',
}

export const vehicleCategory = [
  {
    label: 'Old Vehicle',
    value: 'ov',
  },
  {
    label: 'New Vehicle',
    value: 'nv',
  },
]

export { STORAGE_CONSTANTS } from './storage'
export {
  registrationNumRegex,
  mobileNumRegex,
  emailRegex,
  panNumRegex,
  gstRegex,
  onlyAlphabetsRegex,
} from './regex'
